/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Review_PagesInputs */

const en_mobile_scan_review_pages = /** @type {(inputs: Mobile_Scan_Review_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review pages`)
};

const es_mobile_scan_review_pages = /** @type {(inputs: Mobile_Scan_Review_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar páginas`)
};

/**
* | output |
* | --- |
* | "Review pages" |
*
* @param {Mobile_Scan_Review_PagesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_review_pages = /** @type {((inputs?: Mobile_Scan_Review_PagesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Review_PagesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_review_pages(inputs)
	return en_mobile_scan_review_pages(inputs)
});